import { MultiString } from "../../../library-js/i18n/MultiString";

export class GeneralLocales
{
  static readonly loadingLoaderInfo:MultiString = { en:"LOADING", de:"LADEN" };
  static readonly hintUpperCase:MultiString = { en:"HINT", de:"HINWEISE" };
}